import React, { useEffect, useState } from 'react';
import { Box, Tab } from '@mui/material';
import { RolesTabLabel } from '@/types';
import { FloatingLine, ManagementTabs } from '../styles';
import { useSetAtom } from 'jotai';
import { userManagementSearchPlaceholder } from '../state';
import { PermissionsTable } from './PermissionsTable';
import { MembersTable } from './MembersTable';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function accessibilityProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

type Props = {
  selectedRoleID: string;
  selectedRoleName: string;
  selectedRole: string | undefined;
};

const { MEMBERS_TAB, PERMISSIONS_TAB } = RolesTabLabel;

const searchPlaceholders = {
  [MEMBERS_TAB]: 'Search Users',
  [PERMISSIONS_TAB]: 'Search Permissions',
};

export const RoleDetail = ({ selectedRoleID, selectedRoleName, selectedRole }: Props) => {
  const [innerTab, setInnerTab] = useState<RolesTabLabel>(MEMBERS_TAB);

  const setSearchPlaceholder = useSetAtom(userManagementSearchPlaceholder);

  useEffect(() => {
    setSearchPlaceholder(searchPlaceholders[innerTab]);
  }, [innerTab, setSearchPlaceholder]);

  const handleTabChange = (newValue: number) => setInnerTab(newValue);

  return (
    <Box sx={{ width: '100%', pt: 2 }}>
      <Box sx={{ mt: 3 }}>
        <ManagementTabs value={innerTab} onChange={(_, newTab) => handleTabChange(newTab)}>
          <Tab label="Members" {...accessibilityProps(MEMBERS_TAB)} />
          <Tab label="Permissions" {...accessibilityProps(PERMISSIONS_TAB)} />
        </ManagementTabs>
      </Box>
      <FloatingLine />

      {innerTab === MEMBERS_TAB && (
        <TabPanel value={innerTab} index={MEMBERS_TAB}>
          <MembersTable selectedRoleID={selectedRoleID} selectedRoleName={selectedRoleName} />
        </TabPanel>
      )}

      {innerTab === PERMISSIONS_TAB && (
        <TabPanel value={innerTab} index={PERMISSIONS_TAB}>
          <PermissionsTable selectedRole={selectedRole} />
        </TabPanel>
      )}
    </Box>
  );
};
